import React from 'react';

const ImageSettings = ({ formData, updateFormData, convertImageUrl }) => {
  const handleImageUrlChange = (field, value) => {
    const convertedUrl = convertImageUrl(value);
    updateFormData(field, convertedUrl);
  };

  return (
    <>
      {/* Section Profil */}
      <div className="form-section-content">
        <h3 className="section-title">Profil</h3>
        <div className="form-group">
          <label className="form-label" htmlFor="photoUrl">
            Photo de profil (URL)
          </label>
          <input
            type="url"
            id="photoUrl"
            className="form-input"
            placeholder="https://exemple.com/photo.jpg"
            value={formData.photoUrl}
            onChange={(e) => handleImageUrlChange('photoUrl', e.target.value)}
          />
          <small style={{ color: 'var(--text-light)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
            💡 Recommandé : Google Photos, Imgur ou Dropbox
          </small>
        </div>
        
        <div className="form-group">
          <label className="form-label" htmlFor="photoSize">
            Taille de l'image de profil: {formData.photoSize || 100}px
          </label>
          <input
            type="range"
            id="photoSize"
            className="form-range"
            min="60"
            max="150"
            value={formData.photoSize || 100}
            onChange={(e) => updateFormData('photoSize', parseInt(e.target.value))}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--text-light)', marginTop: '5px' }}>
            <span>60px</span>
            <span>150px</span>
          </div>
        </div>
      </div>
      
      {/* Section Bannière */}
      <div className="form-section-content">
        <h3 className="section-title">Bannière</h3>
        <div className="form-group">
          <label className="form-label" htmlFor="banniereUrl">
            Bannière / Logo (URL)
          </label>
          <input
            type="url"
            id="banniereUrl"
            className="form-input"
            placeholder="https://exemple.com/banniere.jpg"
            value={formData.banniereUrl}
            onChange={(e) => handleImageUrlChange('banniereUrl', e.target.value)}
          />
          <small style={{ color: 'var(--text-light)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
            💡 Recommandé : Google Photos, Imgur ou Dropbox
          </small>
        </div>
        
        <div className="form-group">
          <label className="form-label" htmlFor="bannerSize">
            Taille de la bannière: {formData.bannerSize || 200}px
          </label>
          <input
            type="range"
            id="bannerSize"
            className="form-range"
            min="150"
            max="700"
            value={formData.bannerSize || 200}
            onChange={(e) => updateFormData('bannerSize', parseInt(e.target.value))}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--text-light)', marginTop: '5px' }}>
            <span>150px</span>
            <span>700px</span>
          </div>
        </div>
        
        <div className="form-group">
          <label className="form-label" htmlFor="banniereLink">
            Lien de la bannière (optionnel)
          </label>
          <input
            type="url"
            id="banniereLink"
            className="form-input"
            placeholder="https://exemple.com"
            value={formData.lienBanniere}
            onChange={(e) => updateFormData('lienBanniere', e.target.value)}
          />
          <small style={{ color: 'var(--text-light)', fontSize: '12px', marginTop: '5px', display: 'block' }}>
            💡 La bannière sera cliquable si un lien est fourni
          </small>
        </div>
      </div>
    </>
  );
};

export default ImageSettings;